import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { publicOperationMiddleware } from '../../../permissions/middlewares/publicOperationMiddleware.js';
import { throttleMiddleware } from '../../../request-middlewares/throttelMiddleware.js';
import { resolveLoginWithSuSUpdateToken } from '../server/resolveLoginWithSuSUpdateToken.js';

/**
 * Logs the guardian of a SuS update link in and returns the guardian's id.
 */
export const loginWithSuSUpdateToken = registerMutation({
  operationName: 'loginWithSuSUpdateToken',
  type: () => String,
  params: [{ type: () => String, name: 'token' }],
  middlewares: [
    publicOperationMiddleware('Durch signiertes SUS_REGISTRATION-Token mit Aktualisierungs-Freigabe geschuetzt'),
    throttleMiddleware(2000),
  ],
  resolve: resolveLoginWithSuSUpdateToken,
});
